import z from "zod";

export const workerIncomeEntityType = "worker-income";

export const getWorkerIncomeQueryParamsSchema = z.object({
  filter: z.object({
    year: z.object({
      eq: z.number(),
    }),
  }),
});
export type GetWorkerIncomeQueryParams = z.infer<typeof getWorkerIncomeQueryParamsSchema>;

export const getWorkerIncomeResponseSchema = z.object({
  data: z.object({
    id: z.string(),
    type: z.literal(workerIncomeEntityType),
    attributes: z.object({
      totalAmountInCents: z.number(),
    }),
  }),
});
export type GetWorkerIncomeResponse = z.infer<typeof getWorkerIncomeResponseSchema>;
